import React, {CSSProperties} from 'react'

import {Link, ListItem, Popover} from '../../UI/index.js'
import {buttonResetStyle} from '../../UI/buttons/styles.js'
import {focusableClass, ensureFocusStyles} from '../../UI/styles.js'
import {mapAttributionSizes, mapSpacing, mapZIndex} from '../styles.js'

ensureFocusStyles()

interface MapAttributionProps {
    /** The map has the scale control at the bottom left, the logo goes right of it */
    withScale?: boolean
}

const sources = [
    {label: 'Leaflet', href: 'https://leafletjs.com'},
    {label: '© Mapbox', href: 'https://www.mapbox.com/about/maps/'},
    {label: '© OpenStreetMap', href: 'https://www.openstreetmap.org/copyright'},
    {label: 'Improve this map', href: 'https://www.mapbox.com/map-feedback/'}
]

/**
 * The credits every map shows instead of Leaflet's attribution control: the Mapbox logo at the bottom left and an
 * info button at the bottom right that lists the sources.
 */
export default function MapAttribution({withScale}: MapAttributionProps) {
    const logoStyle: CSSProperties = {
        position: 'absolute',
        left: withScale ? mapAttributionSizes.logoLeftWithScale : mapSpacing.inset,
        bottom: mapSpacing.inset,
        height: mapAttributionSizes.logoHeight,
        zIndex: mapZIndex.attribution,
        overflow: 'hidden'
    }

    return (
        <>
            <img src='/images/mapboxLogo.png' alt='Mapbox' style={logoStyle} />

            <div style={{position: 'absolute', right: mapSpacing.inset, bottom: 0, zIndex: mapZIndex.attribution}}>
                <Popover
                    placement='top-left'
                    content={
                        <div>
                            {sources.map(({label, href}) => (
                                <ListItem key={href} size='sm'><Link href={href}>{label}</Link></ListItem>
                            ))}
                        </div>
                    }
                >
                    <button
                        type='button'
                        aria-label='Kaartbronnen'
                        className={focusableClass}
                        style={{...buttonResetStyle, display: 'block', marginRight: mapSpacing.inset, color: 'white', fontSize: mapAttributionSizes.iconSize, cursor: 'pointer'}}
                    >
                        <i aria-hidden className='mdi mdi-information-outline' />
                    </button>
                </Popover>
            </div>
        </>
    )
}
